export default __webpack_public_path__ + "static/media/arrow.c0b70997.svg";